import { Component, Input, OnInit } from '@angular/core';
import { ORDER_STATUS } from '../../../../../enums';

interface StatusConfig {
  class: string[];
  status?: string;
}

@Component({
  selector: 'app-order-status-modern-view',
  templateUrl: './order-status-modern-view.component.html',
  styleUrls: ['./order-status-modern-view.component.scss'],
})
export class OrderStatusModernViewComponent implements OnInit {
  @Input() orderStatus: string;

  statuses: Record<string, StatusConfig> = {
    completed: {
      class: ['order-status--completed'],
      status: 'Completed',
    },
    pending: {
      class: ['order-status--pending'],
      status: 'Pending',
    },
    active: {
      class: ['order-status--active'],
      status: 'Active',
    },
    draft: {
      class: ['order-status--draft'],
      status: 'Draft',
    },
    lead: {
      class: ['order-status--lead'],
      status: 'Lead',
    },
    quoted: {
      class: ['order-status--quoted'],
      status: 'Quoted',
    },
    expired: {
      class: ['order-status--expired'],
      status: 'Expired',
    },
    [ORDER_STATUS.PUBLISHED]: {
      class: ['order-status--published'],
      status: 'Published',
    },
    [ORDER_STATUS.DECLINED]: {
      class: ['order-status--declined'],
      status: 'Declined',
    },
    [ORDER_STATUS.CLAIMED]: {
      class: ['order-status--claimed'],
      status: 'Claimed',
    },
    [ORDER_STATUS.DISPATCHED]: {
      class: ['order-status--dispatched'],
      status: 'Dipsatched',
    },
    [ORDER_STATUS.CANCELED]: {
      class: ['order-status--cancelled'],
      status: 'Cancelled',
    },
    [ORDER_STATUS.PAID]: {
      class: ['order-status--paid'],
      status: 'Paid',
    },
    [ORDER_STATUS.ON_PICKUP]: {
      class: ['order-status--onpickup'],
      status: 'On Pickup',
    },
    [ORDER_STATUS.ON_WAY_TO_PICKUP]: {
      class: ['order-status--onwaytopickup'],
      status: 'On Way To Pickup',
    },
    [ORDER_STATUS.PICKED_UP]: {
      class: ['order-status--pickedup'],
      status: 'Picked Up',
    },
    [ORDER_STATUS.ON_DELIVERY]: {
      class: ['order-status--ondelivery'],
      status: 'On Delivery',
    },
    [ORDER_STATUS.ON_WAY_TO_DELIVERY]: {
      class: ['order-status--onwaytodelivery'],
      status: 'On Way To Delivery',
    },
    [ORDER_STATUS.DELIVERED]: {
      class: ['order-status--delivered'],
      status: 'Delivered',
    },
    [ORDER_STATUS.ARCHIVED]: {
      class: ['order-status--archived'],
      status: 'Archived',
    },
    [ORDER_STATUS.BILLED]: {
      class: ['order-status--billed'],
      status: 'Billed',
    },
    [ORDER_STATUS.DELETED]: {
      class: ['order-status--deleted'],
      status: 'Deleted',
    },
    [ORDER_STATUS.SIGNATURE_REQUESTED]: {
      class: ['order-status--signaturerequested'],
      status: 'Signature Requested',
    },
    default: {
      class: ['order-status--default'],
    }
  };

  config: StatusConfig;

  ngOnInit() {
    this.config = this.statuses[this.orderStatus.toLowerCase()];
    if (!this.config) {
      this.config = this.statuses['default'];
    }
    this.config.status = this.config.status.toUpperCase();
  }

  // QUOTE = 'new',
  // PUBLISHED = 'published',
  // DECLINED = 'declined',
  // CLAIMED = 'claimed',
  // DISPATCHED = 'dispatched',
  // CANCELED = 'canceled',
  // PAID = 'paid',
  // ON_PICKUP = 'on_pickup',
  // ON_WAY_TO_PICKUP = 'on_way_to_pickup',
  // PICKED_UP = 'picked_up',
  // ON_DELIVERY = 'on_delivery',
  // DELIVERED = 'delivered',
  // ARCHIVED = 'archived',
  // ON_WAY_TO_DELIVERY = 'on_way_to_delivery',
  // SIGNATURE_REQUESTED = 'signature_requested',
  // DELETED = 'deleted',
  // BILLED = 'billed',
  // CANCELED_CLIENT = 'canceled-client',
}
